import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-transfer-blocked-component',
  templateUrl: './transfer-blocked-component.component.html',
  styleUrls: ['./transfer-blocked-component.component.scss']
})
export class TransferBlockedComponentComponent {



  
  @Output() close = new EventEmitter<void>();

}
